import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio3To120(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectRatio3To120"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h8a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M1 4.5A2.5 2.5 0 0 1 3.5 2h8A2.5 2.5 0 0 1 14 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 1 15.5zM16.033 4a.75.75 0 0 1 .75-.75h1.44a.75.75 0 0 1 0 1.5h-1.44a.75.75 0 0 1-.75-.75m0 5.75a.75.75 0 0 1 .75-.75h1.508a.75.75 0 0 1 0 1.5h-1.508a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h.938a.75.75 0 1 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h.938a.75.75 0 0 1 0 1.5h-.938a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio3To120);
